(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1542],{

/***/ 1470:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/buildings",
      function () {
        return __webpack_require__(9195);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1385);
/* harmony import */ var _styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Checkbox = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(param, ref) {
    var title = param.title, view = param.view, checkboxes = param.checkboxes, selected = param.selected, single = param.single, visibility = param.visibility, style = param.style, onChange = param.onChange;
    /** STATES */ var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(function() {
        var values = Array.isArray(selected) ? selected : [
            selected
        ];
        var validatedValues = checkboxes.filter(function(a) {
            return values.includes(a.value.toString());
        }).map(function(x) {
            return x.value.toString();
        });
        return single ? validatedValues[0] ? [
            validatedValues[0]
        ] : [] : validatedValues;
    }), cb = _$ref[0], setCb = _$ref[1];
    /** HANDLERS */ var handleCheckboxClick = function(v) {
        var newCb = cb.includes(v) ? cb.filter(function(item) {
            return item !== v;
        }) : single ? [
            v
        ] : cb.concat([
            v
        ]);
        setCb(newCb);
        if (onChange) onChange(newCb);
    };
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useImperativeHandle)(ref, function() {
        return {
            get: function get() {
                return cb;
            },
            set: function set(v) {
                var values = Array.isArray(v) ? v : [
                    v
                ];
                var validatedValues = checkboxes.filter(function(a) {
                    return values.includes(a.value.toString());
                }).map(function(x) {
                    return x.value.toString();
                });
                setCb(single ? [
                    validatedValues[0]
                ] : validatedValues);
            }
        };
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!selected.length) setCb([]);
        else setCb(Array.isArray(selected) ? single ? [
            selected[0]
        ] : selected : [
            selected
        ]);
    }, [
        selected
    ]);
    /** TEMPLATE */ if (!checkboxes.length || visibility === false) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cb),
            view !== "box" && (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[view]
        ].filter(Boolean).join(" "),
        style: style,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cbTitle),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: [
                    (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cbContent),
                    (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().inline)
                ].join(" "),
                children: checkboxes.map(function(value, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: [
                            (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().cbChekbox),
                            cb.includes(value.value) && (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active),
                            value.disabled && (_styles_modules_Checkbox_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled)
                        ].filter(Boolean).join(" "),
                        onClick: function() {
                            return handleCheckboxClick(value.value);
                        },
                        disabled: value.disabled,
                        children: value.text
                    }, index);
                })
            })
        ]
    });
});
Checkbox.displayName = "Checkbox";
Checkbox.defaultProps = {
    checkboxes: [],
    selected: [],
    visibility: true,
    view: "box"
};
/* harmony default export */ __webpack_exports__["Z"] = (Checkbox);


/***/ }),

/***/ 3177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7865);
/* harmony import */ var _styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1__);



var Skelet = function(param) {
    var children = param.children, height = param.height, maxHeight = param.maxHeight, width = param.width, maxWidth = param.maxWidth, style = param.style, className = param.className, invert = param.invert;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: [
            (_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default().skelet),
            className,
            invert && (_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default().invert)
        ].filter(Boolean).join(" "),
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            height: height,
            maxHeight: maxHeight,
            width: width,
            maxWidth: maxWidth
        }, style),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Skelet);


/***/ }),

/***/ 2040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7333);
/* harmony import */ var _context_location__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(637);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1121);
/* harmony import */ var _Textarea__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3639);
/* harmony import */ var _styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1102);
/* harmony import */ var _styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8__);









var shakeEl = function(el) {
    el.animate([
        {
            transform: "translate3d(-2px, 0, 0)"
        },
        {
            transform: "translate3d(2px, 0, 0)"
        },
        {
            transform: "translate3d(-5px, 0, 0)"
        },
        {
            transform: "translate3d(5px, 0, 0)"
        },
        {
            transform: "translate3d(0, 0, 0)"
        }
    ], 200);
};
var Modal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 2280).then(__webpack_require__.bind(__webpack_require__, 2280));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2280)
            ];
        }
    }
});
var Splitter = function(param) {
    var title = param.title, subtitle = param.subtitle;
    /** STATES */ var locationState = (0,_context_location__WEBPACK_IMPORTED_MODULE_5__/* .useLocationState */ .KJ)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isModalFeedbackVisible = ref[0], setIsModalFeedbackVisible = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isModalSuccessVisible = ref1[0], setIsModalSuccessVisible = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), clientName = ref2[0], setClientName = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), clientPhone = ref3[0], setClientPhone = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), clientComment = ref4[0], setClientComment = ref4[1];
    var clientNameId = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var clientPhoneId = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var inputParentId = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var inputId = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    /** HANDLERS */ var handleFeedbackClick = function() {
        if (clientPhone.length === 11) setIsModalFeedbackVisible(true);
        else shakeEl(inputParentId.current);
    };
    var handleFormSubmit = function() {
        clientNameId.current.setError(clientName.length <= 3);
        clientPhoneId.current.setError(clientPhone.length !== 11);
        if (clientName.length > 3 && clientPhone.length === 11) {
            setIsModalFeedbackVisible(false);
            setIsModalSuccessVisible(true);
            axios__WEBPACK_IMPORTED_MODULE_3___default().post("https://baza.estate/api/v2" + "/client", {
                clientName: clientName,
                clientPhone: clientPhone,
                clientComment: clientComment,
                pathName: window.location.pathname,
                whatComponent: "Splitter",
                location: locationState.region,
                platform: "web"
            });
            inputId.current.value = "";
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Modal, {
                title: "Обратная связь",
                visibility: isModalSuccessVisible,
                onClose: function() {
                    return setIsModalSuccessVisible(false);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            marginBottom: 18
                        },
                        children: "Спасибо за вашу заявку. Мы скоро с Вами свяжемся!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/images/man-with-message.svg",
                        alt: "",
                        style: {
                            margin: 32
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Modal, {
                title: "Обратная связь",
                button: "Отправить",
                action: handleFormSubmit,
                visibility: isModalFeedbackVisible,
                onClose: function() {
                    return setIsModalFeedbackVisible(false);
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            marginBottom: 18
                        },
                        children: "Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки, поможем решить все имеющиеся у Вас вопросы!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        title: "Имя",
                        inputs: [
                            {
                                placeholder: "Иван Петрович",
                                value: clientName,
                                type: "text"
                            }
                        ],
                        isWrappedStyle: true,
                        ref: clientNameId,
                        onChange: function(v) {
                            return setClientName(v[0]);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        title: "Телефон",
                        inputs: [
                            {
                                placeholder: locationState.phone,
                                value: clientPhone,
                                mask: "phone",
                                type: "tel"
                            }
                        ],
                        isWrappedStyle: true,
                        ref: clientPhoneId,
                        onChange: function(v) {
                            return setClientPhone(v[0]);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Textarea__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        title: "Коммментарий",
                        placeholder: "Например, \xabХочу получить консультацию перед продажей своей квартиры в городе\xbb",
                        autoHeight: true,
                        isWrappedStyle: true,
                        onChange: function(v) {
                            return setClientComment(v);
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        style: {
                            textAlign: "center",
                            opacity: 0.8,
                            fontSize: 14,
                            margin: "18px 0"
                        },
                        children: [
                            "Вы соглашаетесь с",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "/faq/policy",
                                target: "_blank",
                                children: "политикой конфиденциальности"
                            }),
                            " ",
                            "при отправке данной формы к нам в работу"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "block fill clear",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: [
                        "fixed",
                        (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().splitter)
                    ].join(" "),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().text),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
                                    children: title
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().subtitle),
                                    children: subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().actions),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().input),
                                    ref: inputParentId,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().inputZone),
                                            format: "+7 ### ### ## ##",
                                            type: "tel",
                                            placeholder: locationState.phone,
                                            getInputRef: inputId,
                                            onChange: function(e) {
                                                return setClientPhone(e.target.value.replace(/[^0-9.]/g, ""));
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().inputButton),
                                            type: "button",
                                            "aria-label": "Отправить",
                                            onClick: handleFeedbackClick,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "24",
                                                height: "24",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                                                        x1: "22",
                                                        y1: "2",
                                                        x2: "11",
                                                        y2: "13"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("polygon", {
                                                        points: "22 2 15 22 11 13 2 9 22 2"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_styles_modules_Splitter_module_scss__WEBPACK_IMPORTED_MODULE_8___default().help),
                                    children: "Введите свой номер телефона в поле выше"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
Splitter.defaultProps = {
    title: "Помочь c продажей?",
    subtitle: "Оставьте свой номер телефона и мы обязательно поможем с продажей"
};
/* harmony default export */ __webpack_exports__["Z"] = (Splitter);


/***/ }),

/***/ 3639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1319);
/* harmony import */ var _styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var Textarea = function(param) {
    var title = param.title, value = param.value, placeholder = param.placeholder, isWrappedStyle = param.isWrappedStyle, isError = param.isError, autoHeight = param.autoHeight, onChange = param.onChange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(value), txt = ref[0], setTxt = ref[1];
    var parentId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var textareaId = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)();
    var handleOnClick = function() {
        if (textareaId.current) textareaId.current.focus();
    };
    var handleOnChange = function(e) {
        if (textareaId.current && autoHeight) {
            textareaId.current.style.height = "auto";
            textareaId.current.style.height = textareaId.current.scrollHeight + "px";
        }
        if (onChange) onChange(e.target.value);
        setTxt(e.target.value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: [
            (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().txt),
            isWrappedStyle && (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().full),
            isError && (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().error)
        ].filter(Boolean).join(" "),
        onClick: handleOnClick,
        ref: parentId,
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().txtTitle),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_modules_Textarea_module_scss__WEBPACK_IMPORTED_MODULE_2___default().txtContent),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
                    onInput: handleOnChange,
                    ref: textareaId,
                    placeholder: placeholder,
                    children: txt
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Textarea);


/***/ }),

/***/ 7198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9815);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6188);
/* harmony import */ var typeof__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(typeof__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks_useIsMount__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9766);
/* harmony import */ var _context_buildings__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1000);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3725);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1121);
/* harmony import */ var _Select__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(360);
/* harmony import */ var _Checkbox__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5113);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2077);
/* harmony import */ var _styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1534);
/* harmony import */ var _styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _data_filters_json__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(6014);
/* harmony import */ var _context_location__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(637);






















var countOfMoreFilters = function(s) {
    var arrMoreFilters = [
        "squareLivingFrom",
        "squareLivingTo",
        "squareKitchenFrom",
        "squareKitchenTo",
        "balcony",
        "ceiling",
        "floorFrom",
        "floorTo",
        "floorsFrom",
        "floorsTo",
        "bathroom",
        "buildingType"
    ];
    var moreFiltersCount = 0;
    for(var i = 0; i < arrMoreFilters.length; i++){
        if (s[arrMoreFilters[i]] && s[arrMoreFilters[i]].length) moreFiltersCount++;
    }
    return moreFiltersCount;
};
var countOfFilters = function(s) {
    var arrMainFilters = [
        "rooms",
        "studio",
        "deadlineQuartal",
        "deadlineYear",
        "priceFrom",
        "priceTo",
        "squareFrom",
        "squareTo",
        "renovation"
    ];
    var mainFiltersCount = 0;
    for(var i = 0; i < arrMainFilters.length; i++)if (s[arrMainFilters[i]] && (s[arrMainFilters[i]].length || s[arrMainFilters[i]] > 0)) mainFiltersCount++;
    return countOfMoreFilters(s) + mainFiltersCount;
};
var isAnyFilterss = function(s) {
    var arrFilters = [
        "rooms",
        "studio",
        "deadlineQuartal",
        "deadlineYear",
        "priceFrom",
        "priceTo",
        "squareFrom",
        "squareTo",
        "renovation",
        "squareLivingFrom",
        "squareLivingTo",
        "squareKitchenFrom",
        "squareKitchenTo",
        "balcony",
        "ceiling",
        "floorFrom",
        "floorTo",
        "floorsFrom",
        "floorsTo",
        "bathroom",
        "buildingType"
    ];
    var filtersTotal = 0;
    for(var i = 0; i < arrFilters.length; i++)if (s[arrFilters[i]] && (s[arrFilters[i]].length || s[arrFilters[i]] > 0)) filtersTotal++;
    return filtersTotal > 0;
};
var valueToNormal = function(k, v) {
    if (k === "studio") return "студия";
    if (k === "rooms") return v.map(function(w) {
        return "".concat(w, "К");
    }).join(", ");
    if (k === "ceiling") return "от ".concat(v, "м");
    if (k === "priceFrom" || k === "priceTo") return "".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_8__/* .moneyText */ .W8)(v));
    if (k === "squareFrom" || k === "squareTo" || k === "squareLivingFrom" || k === "squareLivingTo" || k === "squareKitchenFrom" || k === "squareKitchenTo") return "".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_8__/* .spaceSplitter */ .SE)(v, 3), " м\xb2");
    if (typeof__WEBPACK_IMPORTED_MODULE_4___default()(v) === "string") return v;
    if (typeof__WEBPACK_IMPORTED_MODULE_4___default()(v) === "array") return v.join(", ");
    return "";
};
var BuildingsFilter = function(param) {
    var date = param.date;
    /** STATES */ var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var isMount = (0,_hooks_useIsMount__WEBPACK_IMPORTED_MODULE_6__/* .useIsMount */ .z)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_context_location__WEBPACK_IMPORTED_MODULE_14__/* .useLocationProvider */ .b8)(), 1), locationState = ref[0];
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_context_buildings__WEBPACK_IMPORTED_MODULE_7__/* .useBuildingsProvider */ .iM)(), 2), buildingsState = ref[0], setBuildingsState = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(countOfMoreFilters(buildingsState.filter) > 0), isMoreVisible = ref[0], setIsMoreVisible = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(countOfMoreFilters(buildingsState.filter)), moreFiltersCount = ref[0], setMoreFiltersCount = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(countOfFilters(buildingsState.filter)), filtersCount = ref[0], setFiltersCount = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), foundCount = ref[0], setFoundCount = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.rooms), rooms = ref[0], setRooms = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.studio), studio = ref[0], setStudio = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.deadlineQuartal), deadlineQuartal = ref[0], setDeadlineQuartal = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.deadlineQuartal), deadlineYear = ref[0], setDeadlineYear = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.squareFrom), squareFrom = ref[0], setSquareFrom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.squareTo), squareTo = ref[0], setSquareTo = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.renovation), renovation = ref[0], setRenovation = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.priceFrom), priceFrom = ref[0], setPriceFrom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.priceTo), priceTo = ref[0], setPriceTo = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.squareLivingFrom), squareLivingFrom = ref[0], setSquareLivingFrom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.squareLivingTo), squareLivingTo = ref[0], setSquareLivingTo = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.squareKitchenFrom), squareKitchenFrom = ref[0], setSquareKitchenFrom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.squareKitchenTo), squareKitchenTo = ref[0], setSquareKitchenTo = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.balcony), balcony = ref[0], setBalcony = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.ceiling), ceiling = ref[0], setCeiling = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.floorFrom), floorFrom = ref[0], setFloorFrom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.floorTo), floorTo = ref[0], setFloorTo = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.floorsFrom), floorsFrom = ref[0], setFloorsFrom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.floorsTo), floorsTo = ref[0], setFloorsTo = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.bathroom), bathroom = ref[0], setBathroom = ref[1];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(buildingsState.filter.buildingType), buildingType = ref[0], setBuildingType = ref[1];
    /** FUNCTIONS */ var handleSearchClick = function() {
        setBuildingsState({
            type: "SET_PAGINATION",
            payload: {}
        });
        setBuildingsState({
            type: "SET_FILTER",
            payload: {
                deadlineQuartal: deadlineQuartal,
                deadlineYear: deadlineYear,
                priceFrom: priceFrom,
                priceTo: priceTo,
                studio: studio,
                rooms: rooms,
                squareFrom: squareFrom,
                squareTo: squareTo,
                squareLivingFrom: squareLivingFrom,
                squareLivingTo: squareLivingTo,
                squareKitchenFrom: squareKitchenFrom,
                squareKitchenTo: squareKitchenTo,
                floorFrom: floorFrom,
                floorTo: floorTo,
                floorsFrom: floorsFrom,
                floorsTo: floorsTo,
                ceiling: ceiling,
                balcony: balcony,
                renovation: renovation,
                bathroom: bathroom,
                buildingType: buildingType
            }
        });
    };
    var handleResetClick = function() {
        setDeadlineQuartal("");
        setDeadlineYear("");
        setPriceFrom("");
        setPriceTo("");
        setStudio(0);
        setRooms([]);
        setSquareFrom("");
        setSquareTo("");
        setSquareLivingFrom("");
        setSquareLivingTo("");
        setSquareKitchenFrom("");
        setSquareKitchenTo("");
        setBalcony([]);
        setCeiling("");
        setFloorFrom("");
        setFloorTo("");
        setFloorsFrom("");
        setFloorsTo("");
        setRenovation([]);
        setBuildingType([]);
        setBathroom([]);
        setBuildingsState({
            type: "SET_PAGINATION",
            payload: {}
        });
        setBuildingsState({
            type: "SET_FILTER",
            payload: {}
        });
    };
    var getDeadlineOptions = function() {
        var serverDate = new Date(date);
        var serverDateQuartal = parseInt((serverDate.getMonth() + 1) / 3, 10);
        var variants = [
            {
                type: "option",
                text: "Сдан",
                value: "".concat(serverDateQuartal, ".").concat(serverDate.getFullYear())
            }
        ];
        for(var i = 0; i < 4; i++){
            var year = serverDate.getFullYear() + i;
            for(var j = i === 0 ? serverDateQuartal + 1 : 1; j <= 4; j++){
                variants.push({
                    type: "option",
                    text: "До ".concat(j, " квартала ").concat(year),
                    value: "".concat(j, ".").concat(year)
                });
            }
        }
        return variants;
    };
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isMount) return;
        // console.log(router);
        var newLink = [
            "/",
            router.query.region,
            "/buildings"
        ].join("");
        router.replace("".concat(newLink).concat((0,_helpers__WEBPACK_IMPORTED_MODULE_8__/* .JSONToQuery */ .vp)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, buildingsState.filter, buildingsState.pagination, buildingsState.sorting), [
            "length"
        ], buildingsState.sorting.sort === "price.value" ? [
            "page=1",
            "sort=price.value",
            "sortDirection=asc"
        ] : [
            "page=1"
        ])), undefined, {
            scroll: false
        });
        setMoreFiltersCount(countOfMoreFilters(buildingsState.filter));
        setFiltersCount(countOfFilters(buildingsState.filter));
        if (!countOfMoreFilters(buildingsState.filter)) setIsMoreVisible(false);
    }, [
        buildingsState.filter,
        buildingsState.pagination
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var controller = new AbortController();
        var signal = controller.signal;
        var fetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response;
                return _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setIsLoading(true);
                            _ctx.next = 3;
                            return (0,_helpers__WEBPACK_IMPORTED_MODULE_8__/* .sleep */ ._v)(300);
                        case 3:
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return axios__WEBPACK_IMPORTED_MODULE_3___default().post("https://baza.estate/api/v2" + "/buildings", {
                                deadlineQuartal: deadlineQuartal,
                                deadlineYear: deadlineYear,
                                priceFrom: priceFrom,
                                priceTo: priceTo,
                                studio: studio,
                                rooms: rooms,
                                squareFrom: squareFrom,
                                squareTo: squareTo,
                                squareLivingFrom: squareLivingFrom,
                                squareLivingTo: squareLivingTo,
                                squareKitchenFrom: squareKitchenFrom,
                                squareKitchenTo: squareKitchenTo,
                                floorFrom: floorFrom,
                                floorTo: floorTo,
                                floorsFrom: floorsFrom,
                                floorsTo: floorsTo,
                                ceiling: ceiling,
                                balcony: balcony,
                                renovation: renovation,
                                bathroom: bathroom,
                                buildingType: buildingType,
                                location: locationState.region,
                                stat: 1
                            }, {
                                signal: signal
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 9:
                            setFoundCount(response.data.data.count);
                            setIsLoading(false);
                            _ctx.next = 15;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](3);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        13
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            return controller.abort();
        };
    }, [
        deadlineQuartal,
        deadlineYear,
        priceFrom,
        priceTo,
        studio,
        rooms,
        squareFrom,
        squareTo,
        squareLivingFrom,
        squareLivingTo,
        squareKitchenFrom,
        squareKitchenTo,
        balcony,
        ceiling,
        floorFrom,
        floorTo,
        floorsFrom,
        floorsTo,
        renovation,
        buildingType,
        bathroom
    ]);
    /** TEMPLATE */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
        className: [
            "block",
            (_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default().block)
        ].join(" "),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "fixed",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default().filterContainer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default().filterWrapper),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default().filterGroup),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        title: "Количество комнат",
                                        checkboxes: [
                                            {
                                                text: "Студия",
                                                value: "студия"
                                            },
                                            {
                                                text: "1К",
                                                value: "1"
                                            },
                                            {
                                                text: "2К",
                                                value: "2"
                                            },
                                            {
                                                text: "3К",
                                                value: "3"
                                            },
                                            {
                                                text: "4К+",
                                                value: "4"
                                            }
                                        ],
                                        selected: studio ? [
                                            "студия"
                                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(rooms)) : rooms,
                                        onChange: function(v) {
                                            if (v.includes("студия")) setStudio(1);
                                            else setStudio(0);
                                            setRooms(v.filter(function(x) {
                                                return x !== "студия";
                                            }));
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        title: "Срок сдачи",
                                        options: getDeadlineOptions(),
                                        selected: deadlineQuartal && deadlineYear ? [
                                            "".concat(deadlineQuartal, ".").concat(deadlineYear)
                                        ] : [],
                                        onChange: function(v) {
                                            setDeadlineQuartal(v[0] ? v[0].split(".")[0] : "");
                                            setDeadlineYear(v[0] ? v[0].split(".")[1] : "");
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        title: "Общая площадь",
                                        inputs: [
                                            {
                                                placeholder: "Площадь от",
                                                mask: "number",
                                                value: squareFrom,
                                                max: 999999
                                            },
                                            {
                                                placeholder: "Площадь до",
                                                mask: "number",
                                                value: squareTo,
                                                max: 999999
                                            }
                                        ],
                                        suffix: "м\xb2",
                                        onChange: function(v) {
                                            setSquareFrom(v[0]);
                                            setSquareTo(v[1]);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                        title: "Ремонт",
                                        options: [
                                            {
                                                type: "option",
                                                text: 'Отделка "под ключ"',
                                                value: 'Отделка "под ключ"'
                                            },
                                            {
                                                type: "option",
                                                text: "Подготовка под чистовую отделку",
                                                value: "Подготовка под чистовую отделку"
                                            },
                                            {
                                                type: "option",
                                                text: "Черновая отделка",
                                                value: "Черновая отделка"
                                            }
                                        ],
                                        selected: renovation,
                                        multiple: true,
                                        onChange: function(v) {
                                            setRenovation(v);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        title: "Стоимость",
                                        inputs: [
                                            {
                                                placeholder: "Цена от",
                                                mask: "money",
                                                value: priceFrom,
                                                max: 99999999
                                            },
                                            {
                                                placeholder: "Цена до",
                                                mask: "money",
                                                value: priceTo,
                                                max: 99999999
                                            }
                                        ],
                                        suffix: "₽",
                                        onChange: function(v) {
                                            setPriceFrom(v[0]);
                                            setPriceTo(v[1]);
                                        }
                                    })
                                ]
                            }),
                            isMoreVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: (_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default().filterSplit)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: (_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default().filterGroup),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                title: "Жилая площадь",
                                                inputs: [
                                                    {
                                                        placeholder: "Площадь от",
                                                        mask: "number",
                                                        value: squareLivingFrom,
                                                        max: 999999
                                                    },
                                                    {
                                                        placeholder: "Площадь до",
                                                        mask: "number",
                                                        value: squareLivingTo,
                                                        max: 999999
                                                    }
                                                ],
                                                suffix: "м\xb2",
                                                onChange: function(v) {
                                                    setSquareLivingFrom(v[0]);
                                                    setSquareLivingTo(v[1]);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                title: "Кухонная площадь",
                                                inputs: [
                                                    {
                                                        placeholder: "Площадь от",
                                                        mask: "number",
                                                        value: squareKitchenFrom,
                                                        max: 999999
                                                    },
                                                    {
                                                        placeholder: "Площадь до",
                                                        mask: "number",
                                                        value: squareKitchenTo,
                                                        max: 999999
                                                    }
                                                ],
                                                suffix: "м\xb2",
                                                onChange: function(v) {
                                                    setSquareKitchenFrom(v[0]);
                                                    setSquareKitchenTo(v[1]);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                title: "Балкон",
                                                checkboxes: [
                                                    {
                                                        text: "Балкон",
                                                        value: "балкон"
                                                    },
                                                    {
                                                        text: "Лоджия",
                                                        value: "лоджия"
                                                    }
                                                ],
                                                selected: balcony,
                                                onChange: function(v) {
                                                    setBalcony(v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                title: "Высота потолков",
                                                checkboxes: [
                                                    {
                                                        text: "от 2.5м",
                                                        value: "2.5"
                                                    },
                                                    {
                                                        text: "от 2.7м",
                                                        value: "2.7"
                                                    },
                                                    {
                                                        text: "от 3м",
                                                        value: "3"
                                                    },
                                                    {
                                                        text: "от 4м",
                                                        value: "4"
                                                    }
                                                ],
                                                single: true,
                                                selected: ceiling,
                                                onChange: function(v) {
                                                    setCeiling(v[0]);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                title: "Этаж",
                                                inputs: [
                                                    {
                                                        placeholder: "Этаж от",
                                                        mask: "number",
                                                        value: floorFrom,
                                                        max: 99
                                                    },
                                                    {
                                                        placeholder: "Этаж до",
                                                        mask: "number",
                                                        value: floorTo,
                                                        max: 99
                                                    }
                                                ],
                                                suffix: "эт",
                                                onChange: function(v) {
                                                    setFloorFrom(v[0]);
                                                    setFloorTo(v[1]);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                title: "Этажей",
                                                inputs: [
                                                    {
                                                        placeholder: "Этажей от",
                                                        mask: "number",
                                                        value: floorsFrom,
                                                        max: 999999
                                                    },
                                                    {
                                                        placeholder: "Этажей до",
                                                        mask: "number",
                                                        value: floorsTo,
                                                        max: 999999
                                                    }
                                                ],
                                                suffix: "эт",
                                                onChange: function(v) {
                                                    setFloorsFrom(v[0]);
                                                    setFloorsTo(v[1]);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Checkbox__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                title: "Санузел",
                                                checkboxes: [
                                                    {
                                                        text: "Совмещенный",
                                                        value: "совмещенный"
                                                    },
                                                    {
                                                        text: "Раздельный",
                                                        value: "раздельный"
                                                    },
                                                    {
                                                        text: "Два и более",
                                                        value: "два и более"
                                                    }
                                                ],
                                                selected: bathroom,
                                                onChange: function(v) {
                                                    setBathroom(v);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Select__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                title: "Материал стен дома",
                                                options: [
                                                    {
                                                        type: "option",
                                                        text: "Блочный",
                                                        value: "блочный"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Кирпично-монолитный",
                                                        value: "кирпично-монолитный"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Кирпично-панельный",
                                                        value: "кирпично-панельный"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Кирпичный",
                                                        value: "кирпичный"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Крупно-панельный",
                                                        value: "крупно-панельный"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Монолитно-каркасный",
                                                        value: "монолитно-каркасный"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Монолитный",
                                                        value: "монолитный"
                                                    },
                                                    {
                                                        type: "option",
                                                        text: "Панельный",
                                                        value: "панельный"
                                                    }
                                                ],
                                                selected: buildingType,
                                                multiple: true,
                                                onChange: function(v) {
                                                    setBuildingType(v);
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default().filterActions),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", {
                                        className: (_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default().moreFiltersButton),
                                        type: "button",
                                        onClick: function() {
                                            return setIsMoreVisible(!isMoreVisible);
                                        },
                                        children: [
                                            isMoreVisible ? "Свернуть фильтры" : "Дополнительные фильтры",
                                            moreFiltersCount > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                children: moreFiltersCount
                                            })
                                        ]
                                    }),
                                    filtersCount > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        className: (_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default().resetButton),
                                        color: "red",
                                        onClick: handleResetClick,
                                        style: {
                                            marginLeft: "auto"
                                        },
                                        children: "Очистить"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                        className: (_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default().searchButton),
                                        color: "green",
                                        onClick: handleSearchClick,
                                        loading: isLoading,
                                        children: foundCount > 0 ? "Показать ".concat(foundCount, " ").concat((0,_helpers__WEBPACK_IMPORTED_MODULE_8__/* .declOfNum */ .Ak)(foundCount, [
                                            "квартира",
                                            "квартиры",
                                            "квартир"
                                        ])) : "Найти"
                                    })
                                ]
                            })
                        ]
                    }),
                    isAnyFilterss(buildingsState.filter) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default().filterActiveList),
                        children: [
                            Object.keys(buildingsState.filter).map(function(value, index) {
                                if (Array.isArray(buildingsState.filter[value]) && !buildingsState.filter[value].length || !buildingsState.filter[value] || [
                                    "type",
                                    "category"
                                ].includes(value)) return false;
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                    className: (_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default().filterActiveItem),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                            children: [
                                                _data_filters_json__WEBPACK_IMPORTED_MODULE_13__[value],
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                    children: valueToNormal(value, buildingsState.filter[value])
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                            type: "button",
                                            title: "Удалить фильтр",
                                            onClick: function() {
                                                eval("set".concat((0,_helpers__WEBPACK_IMPORTED_MODULE_8__/* .capitalizeFirstLetter */ .fm)(value), "(").concat((0,_helpers__WEBPACK_IMPORTED_MODULE_8__/* .valueToZero */ .lS)(buildingsState.filter[value]), ")"));
                                                setBuildingsState({
                                                    type: "SET_FILTER",
                                                    payload: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, buildingsState.filter), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)({}, value, (0,_helpers__WEBPACK_IMPORTED_MODULE_8__/* .valueToZero */ .lS)(buildingsState.filter[value])))
                                                });
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "20",
                                                height: "20",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("line", {
                                                        x1: "18",
                                                        y1: "6",
                                                        x2: "6",
                                                        y2: "18"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("line", {
                                                        x1: "6",
                                                        y1: "6",
                                                        x2: "18",
                                                        y2: "18"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, index);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_styles_modules_buildings_BuildingsFilter_module_scss__WEBPACK_IMPORTED_MODULE_18___default().filterActiveItemDummy)
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BuildingsFilter);


/***/ }),

/***/ 9766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useIsMount; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useIsMount = function() {
    var isMountRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        isMountRef.current = false;
    }, []);
    return isMountRef.current;
};


/***/ }),

/***/ 9195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _region_buildings; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./context/buildings.js
var buildings = __webpack_require__(1000);
// EXTERNAL MODULE: ./components/Header.js + 4 modules
var Header = __webpack_require__(798);
// EXTERNAL MODULE: ./components/Footer.js
var Footer = __webpack_require__(3193);
// EXTERNAL MODULE: ./components/Splitter.js
var Splitter = __webpack_require__(2040);
// EXTERNAL MODULE: ./components/Button.js
var Button = __webpack_require__(2077);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 173 modules
var motion = __webpack_require__(8548);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./components/Skelet.js
var Skelet = __webpack_require__(3177);
// EXTERNAL MODULE: ./styles/modules/buildings/BuildingsCatalogItem.module.scss
var BuildingsCatalogItem_module = __webpack_require__(4609);
var BuildingsCatalogItem_module_default = /*#__PURE__*/__webpack_require__.n(BuildingsCatalogItem_module);
;// CONCATENATED MODULE: ./components/buildings/BuildingsCatalogSkeletonItem.js



var BuildingsCatalogSkeletonItem = function() {
    /** TEMPLATE */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (BuildingsCatalogItem_module_default()).item,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BuildingsCatalogItem_module_default()).itemBuilding,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                        className: (BuildingsCatalogItem_module_default()).itemBuildingTitle,
                        height: 33,
                        width: 200
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                        className: (BuildingsCatalogItem_module_default()).itemBuildingSubtitle,
                        height: 21,
                        width: 300
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                        className: (BuildingsCatalogItem_module_default()).itemBuildingDescription,
                        height: 100
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (BuildingsCatalogItem_module_default()).itemBuildingPreview,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                            style: {
                                borderRadius: 19,
                                height: 200
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BuildingsCatalogItem_module_default()).itemContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (BuildingsCatalogItem_module_default()).itemLabels,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                                className: (BuildingsCatalogItem_module_default()).itemLabel,
                                width: 80,
                                height: 80,
                                style: {
                                    borderRadius: "50%"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                                className: (BuildingsCatalogItem_module_default()).itemLabel,
                                width: 80,
                                height: 80,
                                style: {
                                    borderRadius: "50%"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                                className: (BuildingsCatalogItem_module_default()).itemLabel,
                                width: 80,
                                height: 80,
                                style: {
                                    borderRadius: "50%"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (BuildingsCatalogItem_module_default()).itemVariants,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                            className: (BuildingsCatalogItem_module_default()).itemVariant,
                            style: {
                                width: "calc(100% - 32px)",
                                height: "80px"
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var buildings_BuildingsCatalogSkeletonItem = (BuildingsCatalogSkeletonItem);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 4 modules
var AnimatePresence = __webpack_require__(5820);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(5518);
// EXTERNAL MODULE: ./styles/modules/buildings/BuildingsCatalogSort.module.scss
var BuildingsCatalogSort_module = __webpack_require__(7286);
var BuildingsCatalogSort_module_default = /*#__PURE__*/__webpack_require__.n(BuildingsCatalogSort_module);
;// CONCATENATED MODULE: ./components/buildings/BuildingsCatalogSort.js







var BuildingsCatalogSort = function(param) {
    var content = param.content;
    /** STATES */ var setBuildingsState = (0,buildings/* useBuildingsDispatch */.YK)();
    var ref = (0,react.useState)(false), isVisible = ref[0], setVisibility = ref[1];
    var ref1 = (0,react.useState)(content.filter(function(value) {
        return value.selected;
    })[0]), selected = ref1[0], setSelected = ref1[1];
    /** REFS */ var parentEl = (0,react.useRef)(null);
    var selectEl = (0,react.useRef)(null);
    /** HANDLERS */ var handleOutsideClick = function(e) {
        if (e.target.closest(".".concat((BuildingsCatalogSort_module_default()).sort)) !== parentEl.current) setVisibility(false);
    };
    /** HOOKS */ (0,react.useEffect)(function() {
        document.body.addEventListener("click", handleOutsideClick);
        return function() {
            return document.body.removeEventListener("click", handleOutsideClick);
        };
    }, []);
    /** TEMPLATES */ if (lib/* isMobile */.tq) return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        ref: parentEl,
        type: "button",
        className: (BuildingsCatalogSort_module_default()).sort,
        onClick: function() {
            return selectEl.current.focus();
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                ref: selectEl,
                onChange: function(e) {
                    var selectedOption = (0,_to_consumable_array/* default */.Z)(e.target.options).filter(function(x) {
                        return x.selected;
                    })[0];
                    var groupedSelected = {
                        text: selectedOption.innerText,
                        sort: selectedOption.value,
                        direction: selectedOption.dataset.direction
                    };
                    setSelected(groupedSelected);
                    setBuildingsState({
                        type: "SET_PAGINATION",
                        payload: {
                            page: 1
                        }
                    });
                    setBuildingsState({
                        type: "SET_SORTING",
                        payload: {
                            sort: groupedSelected.sort,
                            sortDirection: groupedSelected.direction
                        }
                    });
                },
                children: content.map(function(value, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        "data-direction": value.direction,
                        value: value.sort,
                        defaultValue: value.selected ? "selected" : null,
                        children: value.text
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BuildingsCatalogSort_module_default()).sortShowcase,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (BuildingsCatalogSort_module_default()).sortText,
                        children: selected.text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M8 5V19",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M16 19V5",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M12 14L8 19L4 14",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M12.0039 10L16.0039 5L20.0039 10",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: parentEl,
        className: (BuildingsCatalogSort_module_default()).sort,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BuildingsCatalogSort_module_default()).sortShowcase,
                role: "button",
                tabIndex: 0,
                onClick: function() {
                    return setVisibility(!isVisible);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (BuildingsCatalogSort_module_default()).sortText,
                        children: selected.text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M8 5V19",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M16 19V5",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M12 14L8 19L4 14",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                d: "M12.0039 10L16.0039 5L20.0039 10",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                children: isVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                    initial: {
                        opacity: 0,
                        y: 12
                    },
                    animate: {
                        opacity: 1,
                        y: 0
                    },
                    exit: {
                        opacity: 0,
                        y: 12,
                        transition: {
                            duration: 0.2
                        }
                    },
                    className: (BuildingsCatalogSort_module_default()).sortPicker,
                    children: content.map(function(value, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            className: [
                                (BuildingsCatalogSort_module_default()).sortElement,
                                value.sort === selected.sort && value.direction === selected.direction ? (BuildingsCatalogSort_module_default()).selected : null
                            ].join(" "),
                            onClick: function(e) {
                                setVisibility(false);
                                if (!e.target.classList.contains((BuildingsCatalogSort_module_default()).selected)) {
                                    setSelected(value);
                                    setBuildingsState({
                                        type: "SET_PAGINATION",
                                        payload: {
                                            page: 1
                                        }
                                    });
                                    setBuildingsState({
                                        type: "SET_SORTING",
                                        payload: {
                                            sort: value.sort,
                                            sortDirection: value.direction
                                        }
                                    });
                                }
                            },
                            children: value.text
                        }, index);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var buildings_BuildingsCatalogSort = (BuildingsCatalogSort);

// EXTERNAL MODULE: ./context/location.js
var context_location = __webpack_require__(637);
// EXTERNAL MODULE: ./helpers/index.js
var helpers = __webpack_require__(3725);
// EXTERNAL MODULE: ./hooks/useIsMount.js
var useIsMount = __webpack_require__(9766);
// EXTERNAL MODULE: ./styles/modules/buildings/BuildingsCatalog.module.scss
var BuildingsCatalog_module = __webpack_require__(4775);
var BuildingsCatalog_module_default = /*#__PURE__*/__webpack_require__.n(BuildingsCatalog_module);
;// CONCATENATED MODULE: ./components/buildings/BuildingsCatalog.js



















var generatePagination = function(current, last) {
    var delta = 1;
    var left = current - delta;
    var right = current + delta + 1;
    var range = [];
    var rangeWithDots = [];
    var l;
    for(var i = 1; i <= last; i += 1){
        if (i === 1 || i === last || i >= left && i < right) {
            range.push(i);
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // eslint-disable-next-line no-restricted-syntax
        for(var _iterator = range[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i1 = _step.value;
            if (l) {
                if (i1 - l === 2) {
                    rangeWithDots.push(l + 1);
                } else if (i1 - l !== 1) {
                    rangeWithDots.push(null);
                }
            }
            rangeWithDots.push(i1);
            l = i1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return rangeWithDots;
};
var BuildingsCatalogItem = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8642)]).then(__webpack_require__.bind(__webpack_require__, 8642));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8642)
            ];
        }
    },
    suspense: true
});
var BuildingsCatalog = function() {
    /** STATES */ var isMount = (0,useIsMount/* useIsMount */.z)();
    var locationState = (0,context_location/* useLocationState */.KJ)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,buildings/* useBuildingsProvider */.iM)(), 2), buildingsState = ref[0], setBuildingsState = ref[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), isLoadingData = ref2[0], setIsLoadingData = ref2[1];
    var ref3 = (0,react.useState)(false), isError = ref3[0], setIsError = ref3[1];
    var ref4 = (0,react.useState)(null), data = ref4[0], setData = ref4[1];
    var ref5 = (0,react.useState)(null), totalFlats = ref5[0], setTotalFlats = ref5[1];
    var ref6 = (0,react.useState)(null), totalBuildings = ref6[0], setTotalBuildings = ref6[1];
    var ref7 = (0,react.useState)(null), page = ref7[0], setPage = ref7[1];
    var ref8 = (0,react.useState)(null), pages = ref8[0], setPages = ref8[1];
    /** HOOKS */ (0,react.useEffect)(function() {
        var controller = new AbortController();
        var signal = controller.signal;
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            setIsLoading(true);
                            _ctx.next = 4;
                            return (0,helpers/* sleep */._v)(300);
                        case 4:
                            _ctx.next = 6;
                            return axios_default().post("https://baza.estate/api/v2" + "/buildings", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buildingsState.filter, buildingsState.pagination, buildingsState.sorting), {
                                location: locationState.region
                            }), {
                                signal: signal
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 9:
                            setTotalBuildings(response.data.totalBuildings);
                            setTotalFlats(response.data.totalFlats);
                            setPage(response.data.data.current_page);
                            setPages(response.data.data.last_page);
                            setData(response.data.data.data);
                            setIsLoading(false);
                            setIsError(false);
                            _ctx.next = 21;
                            break;
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](0);
                            if (_ctx.t0.code !== "ERR_CANCELED") {
                                setIsLoading(false);
                                setIsError(true);
                            }
                        case 21:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        18
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            return controller.abort();
        };
    }, [
        buildingsState.filter,
        locationState
    ]);
    (0,react.useEffect)(function() {
        if (isMount || isLoading) return;
        var controller = new AbortController();
        var signal = controller.signal;
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            setIsLoadingData(true);
                            _ctx.next = 4;
                            return (0,helpers/* sleep */._v)(300);
                        case 4:
                            _ctx.next = 6;
                            return axios_default().post("https://baza.estate/api/v2" + "/buildings", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buildingsState.filter, buildingsState.pagination, buildingsState.sorting), {
                                location: locationState.region
                            }), {
                                signal: signal
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 9:
                            setPage(response.data.data.current_page);
                            setData(response.data.data.data);
                            setIsLoadingData(false);
                            setIsError(false);
                            _ctx.next = 18;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            if (_ctx.t0.code !== "ERR_CANCELED") {
                                setIsLoadingData(false);
                                setIsError(true);
                            }
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            return controller.abort();
        };
    }, [
        buildingsState.pagination
    ]);
    (0,react.useEffect)(function() {
        return window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [
        locationState
    ]);
    /** FUNCTIONS */ var handlePagingClick = function(value) {
        var modificator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (value + modificator === page || value + modificator <= 0 || value + modificator > pages) return;
        setPage(value + modificator);
        setBuildingsState({
            type: "SET_PAGINATION",
            payload: {
                page: value + modificator
            }
        });
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var isSortSelected = function(sort, dir) {
        if (!sort) return false;
        if (buildingsState.sorting.sort === sort) {
            if (dir) {
                if (buildingsState.sorting.sortDirection === dir) return true;
                return false;
            }
            return true;
        }
        return false;
    };
    /** TEMPLATES */ if (isLoading || isError) return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: [
            "block",
            (BuildingsCatalog_module_default()).clear
        ].join(" "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: [
                "fixed",
                (BuildingsCatalog_module_default()).catalog
            ].join(" "),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (BuildingsCatalog_module_default()).catalogHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                            height: 32,
                            maxWidth: 400,
                            className: (BuildingsCatalog_module_default()).catalogHeaderTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Skelet/* default */.Z, {
                            height: 32,
                            maxWidth: 200,
                            className: (BuildingsCatalog_module_default()).catalogHeaderActions
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (BuildingsCatalog_module_default()).catalogContent,
                    children: (0,_to_consumable_array/* default */.Z)(Array(5).keys()).map(function(value) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(buildings_BuildingsCatalogSkeletonItem, {}, value);
                    })
                })
            ]
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: [
            "block",
            (BuildingsCatalog_module_default()).clear
        ].join(" "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: [
                "fixed",
                (BuildingsCatalog_module_default()).catalog
            ].join(" "),
            children: [
                data.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (BuildingsCatalog_module_default()).catalogHeader,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (BuildingsCatalog_module_default()).catalogHeaderTitle,
                            children: [
                                (0,helpers/* declOfNum */.Ak)(totalFlats, [
                                    "Найдена",
                                    "Найдено",
                                    "Найдено"
                                ]),
                                " ",
                                totalFlats,
                                " ",
                                (0,helpers/* declOfNum */.Ak)(totalFlats, [
                                    "квартира",
                                    "квартиры",
                                    "квартир"
                                ]),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    children: [
                                        "в ",
                                        totalBuildings,
                                        " ЖК"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (BuildingsCatalog_module_default()).catalogHeaderActions,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(buildings_BuildingsCatalogSort, {
                                content: [
                                    {
                                        text: "По сроку сдачи",
                                        sort: "built-year.max",
                                        selected: isSortSelected("built-year.max")
                                    },
                                    {
                                        text: "Цена по возрастанию",
                                        sort: "price.value",
                                        direction: "asc",
                                        selected: isSortSelected("price.value", "asc")
                                    },
                                    {
                                        text: "Цена по убыванию",
                                        sort: "price.value",
                                        direction: "desc",
                                        selected: isSortSelected("price.value", "desc")
                                    },
                                    {
                                        text: "Цена по возрастанию за м\xb2",
                                        sort: "priceM2",
                                        direction: "asc",
                                        selected: isSortSelected("priceM2", "asc")
                                    },
                                    {
                                        text: "Цена по убыванию за м\xb2",
                                        sort: "priceM2",
                                        direction: "desc",
                                        selected: isSortSelected("priceM2", "desc")
                                    }
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (BuildingsCatalog_module_default()).catalogContent,
                    children: isLoadingData ? (0,_to_consumable_array/* default */.Z)(Array(3).keys()).map(function(value) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(buildings_BuildingsCatalogSkeletonItem, {}, value);
                    }) : data.length > 0 ? data.map(function(value, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Suspense, {
                            fallback: /*#__PURE__*/ (0,jsx_runtime.jsx)(buildings_BuildingsCatalogSkeletonItem, {}),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildingsCatalogItem, {
                                item: value
                            })
                        }, index);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion/* motion.div */.E.div, {
                        initial: {
                            opacity: 0,
                            scale: 0.5
                        },
                        animate: {
                            opacity: 1,
                            scale: 1,
                            transition: {
                                duration: 1,
                                type: "spring",
                                bounce: 0.6
                            }
                        },
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                style: {
                                    marginBottom: 8
                                },
                                children: [
                                    "Нет вариантов в ",
                                    locationState.case
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    opacity: 0.6,
                                    textAlign: "center",
                                    margin: "0 18px"
                                },
                                children: "Попробуйте изменить фильтры или расширить область поиска"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/no_results.svg",
                                alt: "",
                                style: {
                                    width: "100%",
                                    maxWidth: 400,
                                    margin: "18px 32px"
                                }
                            })
                        ]
                    })
                }),
                pages > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (BuildingsCatalog_module_default()).catalogFooter,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (BuildingsCatalog_module_default()).catalogFooterLeft,
                            type: "button",
                            "aria-label": "Предыдущая страница",
                            onClick: function() {
                                return handlePagingClick(page, -1);
                            },
                            style: {
                                cursor: page <= 1 ? "not-allowed" : null,
                                opacity: page <= 1 ? 0.1 : null
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                    points: "15 18 9 12 15 6"
                                })
                            })
                        }),
                        generatePagination(page, pages).map(function(value, index) {
                            if (!value) return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: "..."
                            }, index);
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: [
                                    (BuildingsCatalog_module_default()).catalogFooterButton,
                                    value === page ? (BuildingsCatalog_module_default()).active : ""
                                ].join(" "),
                                type: "button",
                                onClick: function() {
                                    return handlePagingClick(value);
                                },
                                style: {
                                    cursor: value === page ? "default" : null
                                },
                                children: value
                            }, index);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (BuildingsCatalog_module_default()).catalogFooterRight,
                            type: "button",
                            "aria-label": "Следующая страница",
                            onClick: function() {
                                return handlePagingClick(page, 1);
                            },
                            style: {
                                cursor: page >= pages ? "not-allowed" : null,
                                opacity: page >= pages ? 0.1 : null
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polyline", {
                                    points: "9 18 15 12 9 6"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var buildings_BuildingsCatalog = (BuildingsCatalog);

// EXTERNAL MODULE: ./components/buildings/BuildingsFilter.js
var BuildingsFilter = __webpack_require__(7198);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/Input.js
var Input = __webpack_require__(1121);
// EXTERNAL MODULE: ./components/Checkbox.js
var Checkbox = __webpack_require__(5113);
// EXTERNAL MODULE: ./components/Select.js
var Select = __webpack_require__(360);
// EXTERNAL MODULE: ./styles/modules/buildings/BuildingsFilterMobile.module.scss
var BuildingsFilterMobile_module = __webpack_require__(3425);
var BuildingsFilterMobile_module_default = /*#__PURE__*/__webpack_require__.n(BuildingsFilterMobile_module);
;// CONCATENATED MODULE: ./components/buildings/BuildingsFilterMobile.js




















var Modal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2280).then(__webpack_require__.bind(__webpack_require__, 2280));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(2280)
            ];
        }
    }
});
var isAnyFilterss = function(s) {
    var arrFilters = [
        "rooms",
        "studio",
        "deadlineQuartal",
        "deadlineYear",
        "priceFrom",
        "priceTo",
        "squareFrom",
        "squareTo",
        "renovation",
        "squareLivingFrom",
        "squareLivingTo",
        "squareKitchenFrom",
        "squareKitchenTo",
        "balcony",
        "ceiling",
        "floorFrom",
        "floorTo",
        "floorsFrom",
        "floorsTo",
        "bathroom",
        "buildingType"
    ];
    var filtersTotal = 0;
    for(var i = 0; i < arrFilters.length; i++){
        if (s[arrFilters[i]] && (s[arrFilters[i]].length || s[arrFilters[i]] > 0)) filtersTotal++;
    }
    return filtersTotal > 0;
};
var BuildingsFilterMobile = function(param) {
    var date = param.date;
    /** STATES */ var router = (0,next_router.useRouter)();
    var isMount = (0,useIsMount/* useIsMount */.z)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,context_location/* useLocationProvider */.b8)(), 1), locationState = ref[0];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,buildings/* useBuildingsProvider */.iM)(), 2), buildingsState = ref1[0], setBuildingsState = ref1[1];
    var ref2 = (0,react.useState)(0), foundCount = ref2[0], setFoundCount = ref2[1];
    var ref3 = (0,react.useState)(true), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref4 = (0,react.useState)(buildingsState.filter.rooms), rooms = ref4[0], setRooms = ref4[1];
    var ref5 = (0,react.useState)(buildingsState.filter.studio), studio = ref5[0], setStudio = ref5[1];
    var ref6 = (0,react.useState)(buildingsState.filter.deadlineQuartal), deadlineQuartal = ref6[0], setDeadlineQuartal = ref6[1];
    var ref7 = (0,react.useState)(buildingsState.filter.deadlineQuartal), deadlineYear = ref7[0], setDeadlineYear = ref7[1];
    var ref8 = (0,react.useState)(buildingsState.filter.squareFrom), squareFrom = ref8[0], setSquareFrom = ref8[1];
    var ref9 = (0,react.useState)(buildingsState.filter.squareTo), squareTo = ref9[0], setSquareTo = ref9[1];
    var ref10 = (0,react.useState)(buildingsState.filter.renovation), renovation = ref10[0], setRenovation = ref10[1];
    var ref11 = (0,react.useState)(buildingsState.filter.priceFrom), priceFrom = ref11[0], setPriceFrom = ref11[1];
    var ref12 = (0,react.useState)(buildingsState.filter.priceTo), priceTo = ref12[0], setPriceTo = ref12[1];
    var ref13 = (0,react.useState)(buildingsState.filter.squareLivingFrom), squareLivingFrom = ref13[0], setSquareLivingFrom = ref13[1];
    var ref14 = (0,react.useState)(buildingsState.filter.squareLivingTo), squareLivingTo = ref14[0], setSquareLivingTo = ref14[1];
    var ref15 = (0,react.useState)(buildingsState.filter.squareKitchenFrom), squareKitchenFrom = ref15[0], setSquareKitchenFrom = ref15[1];
    var ref16 = (0,react.useState)(buildingsState.filter.squareKitchenTo), squareKitchenTo = ref16[0], setSquareKitchenTo = ref16[1];
    var ref17 = (0,react.useState)(buildingsState.filter.balcony), balcony = ref17[0], setBalcony = ref17[1];
    var ref18 = (0,react.useState)(buildingsState.filter.ceiling), ceiling = ref18[0], setCeiling = ref18[1];
    var ref19 = (0,react.useState)(buildingsState.filter.floorFrom), floorFrom = ref19[0], setFloorFrom = ref19[1];
    var ref20 = (0,react.useState)(buildingsState.filter.floorTo), floorTo = ref20[0], setFloorTo = ref20[1];
    var ref21 = (0,react.useState)(buildingsState.filter.floorsFrom), floorsFrom = ref21[0], setFloorsFrom = ref21[1];
    var ref22 = (0,react.useState)(buildingsState.filter.floorsTo), floorsTo = ref22[0], setFloorsTo = ref22[1];
    var ref23 = (0,react.useState)(buildingsState.filter.bathroom), bathroom = ref23[0], setBathroom = ref23[1];
    var ref24 = (0,react.useState)(buildingsState.filter.buildingType), buildingType = ref24[0], setBuildingType = ref24[1];
    /** FUNCTIONS */ var handleSearchClick = function() {
        setBuildingsState({
            type: "SET_FILTER",
            payload: {
                deadlineQuartal: deadlineQuartal,
                deadlineYear: deadlineYear,
                priceFrom: priceFrom,
                priceTo: priceTo,
                studio: studio,
                rooms: rooms,
                squareFrom: squareFrom,
                squareTo: squareTo,
                squareLivingFrom: squareLivingFrom,
                squareLivingTo: squareLivingTo,
                squareKitchenFrom: squareKitchenFrom,
                squareKitchenTo: squareKitchenTo,
                floorFrom: floorFrom,
                floorTo: floorTo,
                floorsFrom: floorsFrom,
                floorsTo: floorsTo,
                ceiling: ceiling,
                balcony: balcony,
                renovation: renovation,
                bathroom: bathroom,
                buildingType: buildingType
            }
        });
        setBuildingsState({
            type: "SET_STATE",
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buildingsState.state), {
                isFiltersMobileVisible: false
            })
        });
    };
    var handleResetClick = function() {
        setDeadlineQuartal("");
        setDeadlineYear("");
        setPriceFrom("");
        setPriceTo("");
        setStudio(0);
        setRooms([]);
        setSquareFrom("");
        setSquareTo("");
        setSquareLivingFrom("");
        setSquareLivingTo("");
        setSquareKitchenFrom("");
        setSquareKitchenTo("");
        setBalcony([]);
        setCeiling("");
        setFloorFrom("");
        setFloorTo("");
        setFloorsFrom("");
        setFloorsTo("");
        setRenovation([]);
        setBuildingType([]);
        setBathroom([]);
        setBuildingsState({
            type: "SET_FILTER",
            payload: {}
        });
        setBuildingsState({
            type: "SET_STATE",
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buildingsState.state), {
                isFiltersMobileVisible: false
            })
        });
    };
    var getDeadlineOptions = function() {
        var variants = [
            {
                type: "option",
                text: "Сдан",
                value: "сдан"
            }
        ];
        var serverDate = new Date(date);
        var serverDateQuartal = parseInt((serverDate.getMonth() + 1) / 3, 10);
        for(var i = 0; i < 4; i++){
            var year = serverDate.getFullYear() + i;
            for(var j = i === 0 ? serverDateQuartal + 1 : 1; j <= 4; j++){
                variants.push({
                    type: "option",
                    text: "До ".concat(j, " квартала ").concat(year),
                    value: "".concat(j, ".").concat(year)
                });
            }
        }
        return variants;
    };
    /** HOOKS */ (0,react.useEffect)(function() {
        if (isMount) return;
        var newLink = [
            "/",
            router.query.region,
            "/buildings"
        ].join("");
        router.replace("".concat(newLink).concat((0,helpers/* JSONToQuery */.vp)((0,_object_spread/* default */.Z)({}, buildingsState.filter, buildingsState.pagination, buildingsState.sorting), [
            "length"
        ], buildingsState.sorting.sort === "price.value" ? [
            "page=1",
            "sort=price.value",
            "sortDirection=asc"
        ] : [
            "page=1"
        ])));
    }, [
        buildingsState.filter,
        buildingsState.pagination
    ]);
    (0,react.useEffect)(function() {
        var controller = new AbortController();
        var signal = controller.signal;
        var fetchData = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var response;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            setIsLoading(true);
                            _ctx.next = 3;
                            return (0,helpers/* sleep */._v)(300);
                        case 3:
                            _ctx.prev = 3;
                            _ctx.next = 6;
                            return axios_default().post("https://baza.estate/api/v2" + "/buildings", {
                                deadlineQuartal: deadlineQuartal,
                                deadlineYear: deadlineYear,
                                priceFrom: priceFrom,
                                priceTo: priceTo,
                                studio: studio,
                                rooms: rooms,
                                squareFrom: squareFrom,
                                squareTo: squareTo,
                                squareLivingFrom: squareLivingFrom,
                                squareLivingTo: squareLivingTo,
                                squareKitchenFrom: squareKitchenFrom,
                                squareKitchenTo: squareKitchenTo,
                                floorFrom: floorFrom,
                                floorTo: floorTo,
                                floorsFrom: floorsFrom,
                                floorsTo: floorsTo,
                                ceiling: ceiling,
                                balcony: balcony,
                                renovation: renovation,
                                bathroom: bathroom,
                                buildingType: buildingType,
                                location: locationState.region,
                                stat: 1
                            }, {
                                signal: signal
                            });
                        case 6:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 9;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 9:
                            setFoundCount(response.data.data.count);
                            setIsLoading(false);
                            _ctx.next = 15;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](3);
                        case 15:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        3,
                        13
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            return controller.abort();
        };
    }, [
        deadlineQuartal,
        deadlineYear,
        priceFrom,
        priceTo,
        studio,
        rooms,
        squareFrom,
        squareTo,
        squareLivingFrom,
        squareLivingTo,
        squareKitchenFrom,
        squareKitchenTo,
        balcony,
        ceiling,
        floorFrom,
        floorTo,
        floorsFrom,
        floorsTo,
        renovation,
        buildingType,
        bathroom
    ]);
    /** TEMPLATE */ return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal, {
        title: "Фильтры",
        visibility: buildingsState.state.isFiltersMobileVisible,
        onClose: function() {
            return setBuildingsState({
                type: "SET_STATE",
                payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buildingsState.state), {
                    isFiltersMobileVisible: false
                })
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                title: "Количество комнат",
                checkboxes: [
                    {
                        text: "Студия",
                        value: "студия"
                    },
                    {
                        text: "1К",
                        value: "1"
                    },
                    {
                        text: "2К",
                        value: "2"
                    },
                    {
                        text: "3К",
                        value: "3"
                    },
                    {
                        text: "4К+",
                        value: "4"
                    }
                ],
                selected: studio ? [
                    "студия"
                ].concat((0,_to_consumable_array/* default */.Z)(rooms)) : rooms,
                onChange: function(v) {
                    if (v.includes("студия")) setStudio(1);
                    else setStudio(0);
                    setRooms(v.filter(function(x) {
                        return x !== "студия";
                    }));
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                title: "Срок сдачи",
                options: getDeadlineOptions(),
                selected: deadlineQuartal && deadlineYear ? [
                    "".concat(deadlineQuartal, ".").concat(deadlineYear)
                ] : [],
                onChange: function(v) {
                    setDeadlineQuartal(v[0] ? v[0].split(".")[0] : "");
                    setDeadlineYear(v[0] ? v[0].split(".")[1] : "");
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                title: "Общая площадь",
                inputs: [
                    {
                        placeholder: "Площадь от",
                        mask: "number",
                        value: squareFrom,
                        max: 999999
                    },
                    {
                        placeholder: "Площадь до",
                        mask: "number",
                        value: squareTo,
                        max: 999999
                    }
                ],
                suffix: "м\xb2",
                onChange: function(v) {
                    setSquareFrom(v[0]);
                    setSquareTo(v[1]);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                title: "Ремонт",
                options: [
                    {
                        type: "option",
                        text: 'Отделка "под ключ"',
                        value: 'Отделка "под ключ"'
                    },
                    {
                        type: "option",
                        text: "Подготовка под чистовую отделку",
                        value: "Подготовка под чистовую отделку"
                    },
                    {
                        type: "option",
                        text: "Черновая отделка",
                        value: "Черновая отделка"
                    }
                ],
                selected: renovation,
                multiple: true,
                onChange: function(v) {
                    setRenovation(v);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                title: "Стоимость",
                inputs: [
                    {
                        placeholder: "Цена от",
                        mask: "money",
                        value: priceFrom,
                        max: 99999999
                    },
                    {
                        placeholder: "Цена до",
                        mask: "money",
                        value: priceTo,
                        max: 99999999
                    }
                ],
                suffix: "₽",
                onChange: function(v) {
                    setPriceFrom(v[0]);
                    setPriceTo(v[1]);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    borderTop: "1px dashed #e8ebef",
                    margin: "18px -12px "
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                title: "Жилая площадь",
                inputs: [
                    {
                        placeholder: "Площадь от",
                        mask: "number",
                        value: squareLivingFrom,
                        max: 999999
                    },
                    {
                        placeholder: "Площадь до",
                        mask: "number",
                        value: squareLivingTo,
                        max: 999999
                    }
                ],
                suffix: "м\xb2",
                onChange: function(v) {
                    setSquareLivingFrom(v[0]);
                    setSquareLivingTo(v[1]);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                title: "Кухонная площадь",
                inputs: [
                    {
                        placeholder: "Площадь от",
                        mask: "number",
                        value: squareKitchenFrom,
                        max: 999999
                    },
                    {
                        placeholder: "Площадь до",
                        mask: "number",
                        value: squareKitchenTo,
                        max: 999999
                    }
                ],
                suffix: "м\xb2",
                onChange: function(v) {
                    setSquareKitchenFrom(v[0]);
                    setSquareKitchenTo(v[1]);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                title: "Балкон",
                checkboxes: [
                    {
                        text: "Балкон",
                        value: "балкон"
                    },
                    {
                        text: "Лоджия",
                        value: "лоджия"
                    }
                ],
                selected: balcony,
                onChange: function(v) {
                    setBalcony(v);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                title: "Высота потолков",
                checkboxes: [
                    {
                        text: "от 2.5м",
                        value: "2.5"
                    },
                    {
                        text: "от 2.7м",
                        value: "2.7"
                    },
                    {
                        text: "от 3м",
                        value: "3"
                    },
                    {
                        text: "от 4м",
                        value: "4"
                    }
                ],
                single: true,
                selected: ceiling,
                onChange: function(v) {
                    setCeiling(v[0]);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                title: "Этаж",
                inputs: [
                    {
                        placeholder: "Этаж от",
                        mask: "number",
                        value: floorFrom,
                        max: 99
                    },
                    {
                        placeholder: "Этаж до",
                        mask: "number",
                        value: floorTo,
                        max: 99
                    }
                ],
                suffix: "эт",
                onChange: function(v) {
                    setFloorFrom(v[0]);
                    setFloorTo(v[1]);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                title: "Этажей",
                inputs: [
                    {
                        placeholder: "Этажей от",
                        mask: "number",
                        value: floorsFrom,
                        max: 999999
                    },
                    {
                        placeholder: "Этажей до",
                        mask: "number",
                        value: floorsTo,
                        max: 999999
                    }
                ],
                suffix: "эт",
                onChange: function(v) {
                    setFloorsFrom(v[0]);
                    setFloorsTo(v[1]);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                title: "Санузел",
                checkboxes: [
                    {
                        text: "Совмещенный",
                        value: "совмещенный"
                    },
                    {
                        text: "Раздельный",
                        value: "раздельный"
                    },
                    {
                        text: "Два и более",
                        value: "два и более"
                    }
                ],
                selected: bathroom,
                onChange: function(v) {
                    setBathroom(v);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                title: "Материал стен дома",
                options: [
                    {
                        type: "option",
                        text: "Блочный",
                        value: "блочный"
                    },
                    {
                        type: "option",
                        text: "Кирпично-монолитный",
                        value: "кирпично-монолитный"
                    },
                    {
                        type: "option",
                        text: "Кирпично-панельный",
                        value: "кирпично-панельный"
                    },
                    {
                        type: "option",
                        text: "Кирпичный",
                        value: "кирпичный"
                    },
                    {
                        type: "option",
                        text: "Крупно-панельный",
                        value: "крупно-панельный"
                    },
                    {
                        type: "option",
                        text: "Монолитно-каркасный",
                        value: "монолитно-каркасный"
                    },
                    {
                        type: "option",
                        text: "Монолитный",
                        value: "монолитный"
                    },
                    {
                        type: "option",
                        text: "Панельный",
                        value: "панельный"
                    }
                ],
                selected: buildingType,
                multiple: true,
                onChange: function(v) {
                    setBuildingType(v);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (BuildingsFilterMobile_module_default()).actions,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "red",
                        fullWidth: true,
                        style: {
                            marginRight: 12
                        },
                        visibility: isAnyFilterss(buildingsState.filter),
                        onClick: handleResetClick,
                        children: "Очистить"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        color: "green",
                        onClick: handleSearchClick,
                        loading: isLoading,
                        fullWidth: true,
                        children: foundCount > 0 ? "Показать ".concat(foundCount, " ").concat((0,helpers/* declOfNum */.Ak)(foundCount, [
                            "квартира",
                            "квартиры",
                            "квартир"
                        ])) : "Найти"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var buildings_BuildingsFilterMobile = (BuildingsFilterMobile);

// EXTERNAL MODULE: ./styles/modules/buildings/Buildings.module.scss
var Buildings_module = __webpack_require__(8409);
var Buildings_module_default = /*#__PURE__*/__webpack_require__.n(Buildings_module);
;// CONCATENATED MODULE: ./pages/[region]/buildings/index.js

















var isAnyFilters = function(s) {
    var arrFilters = [
        "rooms",
        "studio",
        "deadlineQuartal",
        "deadlineYear",
        "priceFrom",
        "priceTo",
        "squareFrom",
        "squareTo",
        "renovation",
        "squareLivingFrom",
        "squareLivingTo",
        "squareKitchenFrom",
        "squareKitchenTo",
        "balcony",
        "ceiling",
        "floorFrom",
        "floorTo",
        "floorsFrom",
        "floorsTo",
        "bathroom",
        "buildingType"
    ];
    var filtersTotal = 0;
    for(var i = 0; i < arrFilters.length; i++)if (s[arrFilters[i]] && (s[arrFilters[i]].length || s[arrFilters[i]] > 0)) filtersTotal++;
    return filtersTotal > 0;
};
var PageBuildings = function(param) {
    var date = param.date;
    /** STATES */ var ref = (0,_sliced_to_array/* default */.Z)((0,buildings/* useBuildingsProvider */.iM)(), 2), buildingsState = ref[0], setBuildingsState = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,context_location/* useLocationProvider */.b8)(), 1), locationState = ref1[0];
    /** FUNCTIONS */ var onSortChange = function(e) {
        var selectedOption = (0,_to_consumable_array/* default */.Z)(e.target.options).filter(function(x) {
            return x.selected;
        })[0];
        var groupedSelected = {
            sort: selectedOption.value.split("/")[0],
            direction: selectedOption.value.split("/")[1]
        };
        setBuildingsState({
            type: "SET_PAGINATION",
            payload: {
                page: 1
            }
        });
        setBuildingsState({
            type: "SET_SORTING",
            payload: {
                sort: groupedSelected.sort,
                sortDirection: groupedSelected.direction
            }
        });
    };
    var openMobileFilters = function() {
        setBuildingsState({
            type: "SET_STATE",
            payload: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, buildingsState.state), {
                isFiltersMobileVisible: true
            })
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Купить квартиру в новостройке в ".concat(locationState.case),
                description: "Продажа жилья в новостройках в ".concat(locationState.case, ". Купить квартиру в новостройке недорого: цены, свежие объявления, срочная продажа."),
                openGraph: {
                    url: "https://".concat("baza.estate"),
                    type: "website",
                    title: "Купить квартиру в новостройке в ".concat(locationState.case),
                    description: "Продажа жилья в новостройках в ".concat(locationState.case, ". Купить квартиру в новостройке недорого: цены, свежие объявления, срочная продажа."),
                    images: [
                        {
                            url: "/images/og-preview.png"
                        }
                    ],
                    site_name: "Baza.estate - база недвижимости"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: "core",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildingsFilter/* default */.Z, {
                        date: date
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buildings_BuildingsFilterMobile, {
                        date: date
                    }),
                    !buildingsState.state.isFiltersMobileVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Buildings_module_default()).filterMobileActions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                onClick: openMobileFilters,
                                color: "black",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "1.7",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("polygon", {
                                            points: "22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (Buildings_module_default()).filterMobileButtonText,
                                        children: "Фильтры"
                                    }),
                                    isAnyFilters(buildingsState.filter) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (Buildings_module_default()).filterMobileButtonMark
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                style: {
                                    width: 52,
                                    height: 52,
                                    marginLeft: 4
                                },
                                withShadow: true,
                                color: "yellow",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        value: "".concat(buildingsState.sorting.sort || "price.value", "/").concat(buildingsState.sorting.sortDirection || "price.asc"),
                                        style: {
                                            position: "absolute",
                                            left: 0,
                                            top: 0,
                                            right: 0,
                                            bottom: 0,
                                            opacity: 0
                                        },
                                        onChange: onSortChange,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "built-year.max",
                                                children: "По сроку сдачи"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "price.value/asc",
                                                children: "Цена по возрастанию"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "price.value/desc",
                                                children: "Цена по убыванию"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "priceM2/asc",
                                                children: "Цена по убыванию за м\xb2"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "priceM2/desc",
                                                children: "Цена по убыванию за м\xb2"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M8 5V19",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M16 19V5",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M12 14L8 19L4 14",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                d: "M12.0039 10L16.0039 5L20.0039 10",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buildings_BuildingsCatalog, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                seo: [
                    "Новостройки",
                    locationState.seo.footer
                ].join(" ")
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _region_buildings = (PageBuildings);


/***/ }),

/***/ 1385:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cb":"Checkbox_cb__zNEBc","inline":"Checkbox_inline__CYSFn","cbTitle":"Checkbox_cbTitle__452ih","cbContent":"Checkbox_cbContent__KmkMt","cbChekbox":"Checkbox_cbChekbox__d52mx","disabled":"Checkbox_disabled__vYV7z","active":"Checkbox_active__c7_cW"};

/***/ }),

/***/ 7865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skelet":"Skelet_skelet__Z3L3p","wheeeee":"Skelet_wheeeee__aGXk5","invert":"Skelet_invert__PLaK3"};

/***/ }),

/***/ 1102:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"splitter":"Splitter_splitter__Mp2tP","text":"Splitter_text__79Zmg","title":"Splitter_title__Fmxhb","subtitle":"Splitter_subtitle__CmYZ2","actions":"Splitter_actions__6lGHR","input":"Splitter_input__2_PBU","inputZone":"Splitter_inputZone__Bj3xv","inputButton":"Splitter_inputButton__efr_F","no-animation":"Splitter_no-animation__2chXz","no-border":"Splitter_no-border__0YEZA","fullWidth":"Splitter_fullWidth__D6CYJ","help":"Splitter_help__Cb_S8"};

/***/ }),

/***/ 1319:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"txt":"Textarea_txt__h9LCE","txtTitle":"Textarea_txtTitle__NdQd9","txtContent":"Textarea_txtContent__t4AHN","full":"Textarea_full__ldXF7","error":"Textarea_error__z_vDn"};

/***/ }),

/***/ 8409:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"filterMobileActions":"Buildings_filterMobileActions__fiIfQ","filterMobileButtonText":"Buildings_filterMobileButtonText__T4eLZ","filterMobileButtonMark":"Buildings_filterMobileButtonMark__MnUPL"};

/***/ }),

/***/ 4775:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"catalog":"BuildingsCatalog_catalog__hqh7s","catalogHeader":"BuildingsCatalog_catalogHeader__doOTX","catalogHeaderTitle":"BuildingsCatalog_catalogHeaderTitle__VMO4p","catalogHeaderActions":"BuildingsCatalog_catalogHeaderActions__T9t68","catalogHeaderSort":"BuildingsCatalog_catalogHeaderSort__I74_J","up":"BuildingsCatalog_up__0efFS","catalogContent":"BuildingsCatalog_catalogContent__6KL3t","catalogFooter":"BuildingsCatalog_catalogFooter__Fx_iI","catalogFooterLeft":"BuildingsCatalog_catalogFooterLeft__kEqtA","catalogFooterRight":"BuildingsCatalog_catalogFooterRight__B_aJa","catalogFooterButton":"BuildingsCatalog_catalogFooterButton__vXsIn","active":"BuildingsCatalog_active__P6Pi1","clear":"BuildingsCatalog_clear__H0syP"};

/***/ }),

/***/ 4609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"BuildingsCatalogItem_item__FuLNY","itemBuilding":"BuildingsCatalogItem_itemBuilding__w8qiz","itemBuildingTitle":"BuildingsCatalogItem_itemBuildingTitle__uRWVl","itemBuildingSubtitle":"BuildingsCatalogItem_itemBuildingSubtitle__O2_pZ","itemBuildingDescription":"BuildingsCatalogItem_itemBuildingDescription__GQ5It","itemBuildingMore":"BuildingsCatalogItem_itemBuildingMore__9OEus","itemBuildingPreview":"BuildingsCatalogItem_itemBuildingPreview__0sD0o","itemBuildingPreviewItem":"BuildingsCatalogItem_itemBuildingPreviewItem__Sm8DG","itemContent":"BuildingsCatalogItem_itemContent__CGuJl","itemLabels":"BuildingsCatalogItem_itemLabels__PP_gQ","itemLabel":"BuildingsCatalogItem_itemLabel__ySCUn","itemLabelIcon":"BuildingsCatalogItem_itemLabelIcon__6gFbw","itemLabelTitle":"BuildingsCatalogItem_itemLabelTitle__EomET","itemLabelSubtitle":"BuildingsCatalogItem_itemLabelSubtitle__XZPP0","itemVariants":"BuildingsCatalogItem_itemVariants__Tb5NI","itemVariant":"BuildingsCatalogItem_itemVariant__F8vzf","itemVariantHeader":"BuildingsCatalogItem_itemVariantHeader___5jcY","itemVariantHeaderTitle":"BuildingsCatalogItem_itemVariantHeaderTitle__XXZAG","itemVariantHeaderPrice":"BuildingsCatalogItem_itemVariantHeaderPrice__F_k5a","itemVariantGallery":"BuildingsCatalogItem_itemVariantGallery__5xXs9","itemVariantGalleryPhoto":"BuildingsCatalogItem_itemVariantGalleryPhoto__N0pJv","itemVariantGalleryMore":"BuildingsCatalogItem_itemVariantGalleryMore__7wnrp"};

/***/ }),

/***/ 7286:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sort":"BuildingsCatalogSort_sort__B9cEB","sortShowcase":"BuildingsCatalogSort_sortShowcase__pRFjP","sortText":"BuildingsCatalogSort_sortText__UVl4o","sortPicker":"BuildingsCatalogSort_sortPicker__OEL9U","sortElement":"BuildingsCatalogSort_sortElement___ozte","selected":"BuildingsCatalogSort_selected__hNzjN"};

/***/ }),

/***/ 1534:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"block":"BuildingsFilter_block____XMk","filterContainer":"BuildingsFilter_filterContainer__2M3zz","filterWrapper":"BuildingsFilter_filterWrapper__K6Cht","filterGroup":"BuildingsFilter_filterGroup___ZCyN","filterSplit":"BuildingsFilter_filterSplit__u4UML","filterActions":"BuildingsFilter_filterActions__98QkX","moreFiltersButton":"BuildingsFilter_moreFiltersButton__sSk8x","resetButton":"BuildingsFilter_resetButton__fChke","searchButton":"BuildingsFilter_searchButton__M_LoT","filterActiveList":"BuildingsFilter_filterActiveList__K0qBO","filterActiveItem":"BuildingsFilter_filterActiveItem__1JXMm","filterActiveItemDummy":"BuildingsFilter_filterActiveItemDummy__cZbwv"};

/***/ }),

/***/ 3425:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"splitter":"BuildingsFilterMobile_splitter__Qe_Wh","actions":"BuildingsFilterMobile_actions__Dk0FS"};

/***/ }),

/***/ 6014:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"type":"Сделка","category":"Категория","priceFrom":"Стоимость от","priceTo":"Стоимость до","rooms":"Комнат","studio":"Комнат","squareFrom":"Площадь от","squareTo":"Площадь до","mikroraion":"Район","locality":"Город","noCommission":"Акция","exclusive":"Акция","squareAreaFrom":"Площадь участка от","squareAreaTo":"Площадь участка до","commercialType":"Назначение объекта","squareLivingFrom":"Жилая площадь от","squareLivingTo":"Жилая площадь до","squareKitchenFrom":"Площадь кухни от","squareKitchenTo":"Площадь кухни до","floorFrom":"Этаж от","floorTo":"Этаж до","floorsFrom":"Этажей от","floorsTo":"Этажей до","ceiling":"Потолок","balcony":"Балкон","renovation":"Ремонт","bathroom":"Санузел","buildingType":"Стены дома","stock":"Здание","lotType":"Участок","subCategory":"Дом","entrance":"Вход","commercialBuildingType":"Здание","deadlineQuartal":"Квартал сдачи","deadlineYear":"Год сдачи"}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [41,2962,5518,798,3193,360,9774,2888,179], function() { return __webpack_exec__(1470); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);